<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
>
  <path
    d="M10.1 2.5a1.4 1.4 0 1 1 1.4 1.4 1.399 1.399 0 0 1-1.4-1.4zm5.381 6.824a.635.635 0 0 0 .643-1.059l-2.314-1.27.109 1.46zM22 13.136V22H2v-3.091l6.305-1.82a.713.713 0 0 1-.395-.146.726.726 0 0 1-.15-.955l2.216-3.443.441-1.626 1.292 1.14-.365 1.3-2.376 3.435a.717.717 0 0 1-.157.149l5.341-1.542a.642.642 0 0 1-.169-.05.659.659 0 0 1-.323-.5l-.305-2.862-2.348-1.884-.298-3.223-1.66 2.859a.532.532 0 0 1-.739.206.52.52 0 0 1-.205-.675c.446-.919 1.507-3.083 2.163-4.248 1.139.07 2.405.16 2.472 1.086l.291 3.886 1.746 1.432.196 3.314a.652.652 0 0 1-.17.472zm-1 1.329L3 19.66V21h18z"
    fill="#ffffff"
  />
</svg>
